import { render } from "./HeaderStats.vue?vue&type=template&id=33fa4a57"
import script from "./HeaderStats.vue?vue&type=script&lang=js"
export * from "./HeaderStats.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__